module.exports = __webpack_public_path__ + "static/media/carregando.8f8ec2db.svg";